import { Label } from "../../../infecto-lms-webapp/components/buttons/Label";

interface OwnProps {
	elementTypeLabel?: string;
	shortDescription: string | null;
	title: string;
}
export const NavigationButtonLabel = ({ elementTypeLabel, shortDescription, title }: OwnProps) => {
	return (
		<Label>
			{elementTypeLabel ? (
				elementTypeLabel
			) : (
				<Label
					dangerouslySetInnerHTML={{
						__html:
							shortDescription && shortDescription !== "<div><br></div>"
								? shortDescription.toUpperCase()
								: title.toUpperCase(),
					}}
				/>
			)}
		</Label>
	);
};
